import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import KnowledgeHub from '@/components/feature/KnowledgeHub';

export default function KnowledgeHubPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <KnowledgeHub />
      </main>
      <Footer />
    </div>
  );
}